import { api } from "./http";

const UserPrefsApi = {
  getMyPrefs: async () => (await api.get("/me/preferences")).data,
  updateMyPrefs: async (data) => (await api.patch("/me/preferences", data)).data,
};
export default UserPrefsApi;
